export const unitsDropDownTransformer = response => {
  return response?.data?.map(item => ({
    label: item?.unitNumber,
    value: item?.id,
    id: item?.id,
    price: item?.price,
    projectConstructionStatus: item?.Project?.construction,
  }))
}
